import { EmployeeShopError } from 'pages/gui-defs/EmployeeShops/types/employeeShops';
import { Shop } from 'pages/gui-defs/EmployeeShops/types/shops';
import { EmployeeShopsState } from '../reducers/employeeShops';

export const ADD_ALL_ACCESS = 'employeeShops/addAllAccess';
export const ADD_SHOP_ACCESS = 'employeeShops/addShopAccess';
export const CLEAR_SHOP_ACCESS = 'employeeShops/clearShopAccess';
export const REMOVE_SHOP_ACCESS = 'employeeShops/removeShopAccess';
export const RESET_STORE = 'employeeShops/resetStore';
export const RESTORE_SHOPS = 'employeeShops/restoreShops';
export const SET_CAN_CHANGE_FULL_ACCESS = 'employeeShops/setCanChangeFullAccess';
export const SET_EMPLOYEE_ID = 'employeeShops/setEmployeeID';
export const SET_ERROR = 'employeeShops/setError';
export const SET_IS_LOADING = 'employeeShops/setIsLoading';
export const SET_IS_PRIMARY_USER = 'employeeShops/setIsPrimaryUser';
export const SET_SHOPS = 'employeeShops/setShops';
export const SET_SHOP_ACCESS = 'employeeShops/setShopAccess';
export const SET_STORE = 'employeeShops/setStore';

export const addAllAccess = () => ({
  type: ADD_ALL_ACCESS,
});

export const addShopAccess = (shopID: number) => ({
  type: ADD_SHOP_ACCESS,
  payload: shopID,
});

export const clearShopAccess = () => ({
  type: CLEAR_SHOP_ACCESS,
});

export const removeShopAccess = (shopID: number) => ({
  type: REMOVE_SHOP_ACCESS,
  payload: shopID,
});

export const resetStore = () => ({
  type: RESET_STORE,
});

export const restoreShops = () => ({
  type: RESTORE_SHOPS,
});

export const setCanChangeFullAccess = (canChangeFullAccess: boolean) => ({
  type: SET_CAN_CHANGE_FULL_ACCESS,
  payload: canChangeFullAccess,
});

export const setEmployeeID = (employeeID: string) => ({
  type: SET_EMPLOYEE_ID,
  payload: employeeID,
});

export const setError = (error: EmployeeShopError) => ({
  type: SET_ERROR,
  payload: error,
});

export const setIsLoading = (isLoading: boolean) => ({
  type: SET_IS_LOADING,
  payload: isLoading,
});

export const setIsPrimaryUser = (isPrimaryUser: boolean) => ({
  type: SET_IS_PRIMARY_USER,
  payload: isPrimaryUser,
});

export const setShops = (shops: Shop[]) => ({
  type: SET_SHOPS,
  payload: shops,
});

export const setShopAccess = (id: number, hasAccess: boolean) => ({
  type: SET_SHOP_ACCESS,
  payload: {
    id,
    hasAccess,
  },
});

export const setStore = (newStore: EmployeeShopsState) => ({
  type: SET_STORE,
  payload: newStore,
});
